module.exports = __webpack_public_path__ + "static/media/05.766052c5.png";